import Alert from './Alert';

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/index.tsx